module.exports = __webpack_public_path__ + "img/car-E-2.f36a5c85.jpg";